import { Model } from ".";

export default class StoreLocation extends Model {
	get singularNoun() {
		return "store location";
	}

	resource() {
		return "stores/locations";
	}
}
